"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Background = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _View = _interopRequireDefault(require("@emcasa/ui-dom/components/View"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var Background = (0, _styledComponents["default"])(_View["default"]).withConfig({
  displayName: "styles__Background",
  componentId: "sc-1owrso5-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,0.5);z-index:999;display:flex;justify-content:center;align-items:center;"]);
exports.Background = Background;
var Container = (0, _styledComponents["default"])(_View["default"]).withConfig({
  displayName: "styles__Container",
  componentId: "sc-1owrso5-1"
})(["display:flex;flex-direction:column;position:relative;cursor:default;background-color:white;width:280px;border-radius:8px;"]);
exports.Container = Container;